// extracted by mini-css-extract-plugin
export default {"colleaguesTooltipList":"CellTooltip_colleaguesTooltipList__4PJf8","colleaguesTooltipItem":"CellTooltip_colleaguesTooltipItem__4xEov"};